import logger from "@/utils/logger.js";
import api from "@/services/api.js";
import { checkToken } from '@/utils/lambdaUtils';

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/exams/';

export const insertExam = async (examData) => {
    if (!examData) {
        throw new Error('Missing required parameters');
    }

    try {
        await checkToken();
        const response = await api.post(`${baseUrl}`, examData);
        return response.data;
    } catch (error) {
        logger.error('Error inserting exam', error);
        throw error;
    }
};

// Fetch all exams for QA file upload page, Includes entity + exam products
export const getAllExams = async () => {
    try {
        await checkToken();
        const response = await api.get(`${baseUrl}fetch_all_exams`);
        return response.data;
    } catch (error) {
        logger.error('Error fetching all exams.', error);
        throw error;
    }
};

// Fetch ExamProducts by ExamId
export const getAllExamProducts = async () => {
    try {
        await checkToken();
        const response = await api.get(`${baseUrl}fetch_all_products`);
        return response.data;
    } catch (error) {
        logger.error('Error fetching exam products', error);
        throw error;
    }
};